module.exports = __webpack_public_path__ + "static/img/4.a190656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg/4.png
// module id = 133
// module chunks = 2